import React, { useState, useEffect } from 'react'
import "./CSS/Login.css"
import { Link } from 'react-router-dom'
import tringle from "../Assets/Triangle-Exclamation-Point.jpg"
import alert from "../Assets/2014825.png"
import { connect, useSelector } from 'react-redux'
import logo from "../Assets/IMG-20230407-WA0001_transparent.png"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { SET_COMPANY_ID, set_email, set_temp_email, set_uid, set_username, setTesis } from "../Action/Action"
import Store from '../Store/Store'
import { authService } from '../services/axiosConfig'


const Login = (props) => {

    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const login_api = "https://app-rmmsapi.azurewebsites.net" + "/api/person/LoginUser"
    const history = useHistory()


    const [err_code, Set_err_code] = useState("")

    const [username, SETusername] = useState("rmms1234")
    const [pwd, Setpwd] = useState("1234567")

    const [inp, SETINP] = useState("")
    const [parola, SetParola] = useState("")
    const [email, SetEmail] = useState("")

    const [email_inital, SetEmail_inital] = useState(props.user_email)

    useEffect(() => {
        if (err_code !== "") {
            setTimeout(() => {
                var alert_ = document.querySelector(".alert_sx-34")
                alert_.firstElementChild.classList.add("alert_part_inactive")
            }, 5000)
        }
    }, [err_code])

    const close_the_alert = e => {
        var alert_ = document.querySelector(".alert_sx-34")
        alert_.firstElementChild.classList.add("alert_part_inactive")
    }

    const Error1 = (inp, msg) => {
        inp.className = "form-control is-invalid"
        const div = inp.nextElementSibling
        div.innerText = msg
        div.className = "inform_login_text invalid-feedback"
    }


    const OnFormSubmit = async e => {
        e.preventDefault();

        if (email !== "info") {




            let password = document.querySelector(".password0login_input") || document.querySelector(".form-control")
            let email_ = document.querySelector(".login0email_input") || document.querySelector(".form-control")

            CheckPassword(password)
            checkEmail(email_)
            checkLength(password, 3, 15)


            if (email_.classList.contains("is-valid") && password.classList.contains("is-valid")) {

                try {
                    const req_ = await fetch(`${login_api}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            "accept": "application/json"
                        },
                        body: JSON.stringify({
                            "email": email,
                            "password": parola
                        }) // Convert the body object to a JSON string
                    })
                    if (!req_.ok) {



                        throw new Error(`HTTP hata kodu: ${req_.status}`);
                    }
                    try {
                        const response = await req_.json()
                        console.log(response);

                        await Store.dispatch(set_email(response.email))
                        await Store.dispatch(set_username(response.userName))
                        await Store.dispatch(set_uid(response.userId))


                        // ✅ Her login'de güncel kullanıcı bilgilerini yaz
                        sessionStorage.setItem("user_id", response.userId);
                        sessionStorage.setItem("username", response.userName);
                        sessionStorage.setItem("user_email", response.email);
                        console.log("🔥🔥🔥 LOGIN SUCCESS");
                        console.log("🔥🔥🔥 Email:", response.email);
                        console.log("🔥🔥🔥 CompanyId from API:", response.companyId, "Type:", typeof response.companyId);

                        // 🔥 Kullanıcının kendi companyId'sini kaydet (SCADA menüsü için)
                        sessionStorage.setItem("user_companyId", response.companyId);

                        // 🔐 JWT Token al ve kaydet
                        try {
                            const tokenResponse = await authService.login(
                                response.email,
                                parola,
                                response.userId,
                                response.companyId
                            );
                            console.log("🔐 JWT Token alındı:", tokenResponse.token ? "OK" : "FAIL");
                        } catch (tokenErr) {
                            console.error("🔐 JWT Token alınamadı:", tokenErr.message);
                        }

                        if (response.companyId === "2") {
                            // TesisSec'e git - sessionStorage'daki eski değerleri temizle!
                            console.log("🔥🔥🔥 LOGIN: Going to TesisSec, clearing old sessionStorage values");
                            sessionStorage.removeItem("TEMPCOM");
                            sessionStorage.removeItem("ucer_id");
                            sessionStorage.removeItem("Tesis");

                            await history.push("/TesisSec")
                            window.location.reload()

                        } else if (response.companyId === "1") {
                            // Ana sayfaya git - TEMPCOM set et
                            sessionStorage.setItem("ucer_id", response.companyId);
                            sessionStorage.setItem("TEMPCOM", response.companyId);
                            sessionStorage.setItem("Tesis", JSON.stringify({ "Akra": "t" }));

                            console.log("🔥🔥🔥 LOGIN: Going to HOME, TEMPCOM =", response.companyId);

                            await Store.dispatch(setTesis({ "Akra": "t" }))
                            await history.push("/")
                            window.location.reload()

                        }else {
                            // Ana sayfaya git - TEMPCOM set et
                            sessionStorage.setItem("ucer_id", response.companyId);
                            sessionStorage.setItem("TEMPCOM", response.companyId);
                            sessionStorage.setItem("Tesis", JSON.stringify({ "Akra": "f" }));

                            console.log("🔥🔥🔥 LOGIN: Going to HOME, TEMPCOM =", response.companyId);

                            await Store.dispatch(setTesis({ "Akra": "f" }))
                            await history.push("/")
                            window.location.reload()

                        }




                    } catch (jsonerr) {
                        Error1(email_, "Email adresi veya parola yanlış!")
                        Error1(password, "Email adresi veya parola yanlış!")
                        console.log("JSON Error: ", jsonerr);
                    }



                } catch (err) {
                    console.log(err, "aüaüaüaüaüaüüaaü");
                }


            }

        } else {
            console.log(email);
            try {
                const req_ = await fetch(`${login_api}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "accept": "application/json"
                    },
                    body: JSON.stringify({
                        "email": email,
                        "password": parola
                    }) // Convert the body object to a JSON string
                })
                if (!req_.ok) {
                    throw new Error(`HTTP hata kodu: ${req_.status}`);
                }
                try {
                    const response = await req_.json()
                    console.log(response);

                    await Store.dispatch(set_email(response.email))
                    await Store.dispatch(set_username(response.userName))
                    await Store.dispatch(set_uid(response.userId))

                    // TesisSec ekranına gidiyorsa TEMPCOM ve ucer_id'yi set etme - kullanıcı orada seçecek

                    // ✅ Her login'de güncel kullanıcı bilgilerini yaz
                    sessionStorage.setItem("user_id", response.userId);
                    sessionStorage.setItem("username", response.userName);
                    sessionStorage.setItem("user_email", response.email);
                    console.log(response);

                    // TesisSec'e giderken sessionStorage temizle
                    sessionStorage.removeItem("TEMPCOM");
                    sessionStorage.removeItem("ucer_id");
                    sessionStorage.removeItem("Tesis");

                } catch (jsonerr) {
                    console.log("JSON Error: ", jsonerr);
                }


                await history.push("/TesisSec")
                window.location.reload()

            } catch (err) {
                console.log(err, "aüaüaüaüaüaüüaaü");
            }




        }

    }


    const Success = (inp) => {
        inp.className = "form-control is-valid"
        const div = inp.nextElementSibling
        div.innerText = ""
        div.className = ""
    }

    const checkEmail = (inp) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (inp.value === "") {
            Error1(inp, "Email gerekli!")
        } else {
            if (re.test(inp.value)) {
                Success(inp)
            } else {
                Error1(inp, "Geçersiz email adresi!")
            }
        }

    }

    const checkEmail2 = (inp) => {
        if (email_inital !== "") {
            if (inp.value !== email_inital) {
                Error1(inp, "")
            }
        } else {
            Success(inp)
        }

    }

    const CheckValidate = (inps) => {
        inps.forEach(inp => {
            if (inp.value === "") {
                Error1(inp, `Bu alan boş bırakılamaz!`)
            } else {
                Success(inp)
                return true
            }
        })
    }



    const checkLength = (inp, min, max) => {
        if (inp.id !== "Email") {
            if (inp.value.length > max) {
                Error1(inp, `${inp.id} en fazla ${max} karakter içerebilir!`)
            } else if (inp.value.length < min) {
                Error1(inp, `${inp.id} en az ${min} karakter içerebilir!`)
            } else {
                Success(inp)
                return true
            }
        }


    }

    function CheckPassword(inp) {
        if (inp.value === "") {
            Error1(inp, `Bu alan boş bırakılamaz!`)
        } else {
            Success(inp)
            return true
        }
    }


    const change_inp = e => {
        SETINP(e.target.value)
    }
    const change_pwd = e => {
        SetParola(e.target.value)
    }
    const change_email = e => {
        SetEmail(e.target.value)
    }

    const [currentHour, SetcurrentHour] = useState(null)
    const [currentMinute, SetcurrentMinute] = useState(null)
    const [currentDay, SetcurrentDay] = useState(null)
    const [currentDay2, SetcurrentDay2] = useState(null)
    const [currentyear, Setcurrentyear] = useState(null)
    const [currentmonth, Setcurrentmonth] = useState(null)


    setInterval(() => {
        let now = new Date();
        SetcurrentHour(now.getHours())
        SetcurrentMinute(now.getMinutes())
        SetcurrentDay(now.getDay())
        Setcurrentmonth(now.getMonth())
        Setcurrentyear(now.getFullYear())
        SetcurrentDay2(daysOfWeek[now.getDay()])

    }, 1000)

    return (
        <>
            <header className='login_header'>
                <nav>
                    <div className="nav-left-part">

                    </div>
                    <div className="middlepart-nav">
                        <div className='nav-time-part'>{currentHour}:{currentMinute < 10 ? `0${currentMinute}` : currentMinute}</div>
                        <div>
                            <div style={{ marginLeft: "5%" }} className="date-part-nav">
                                {currentDay < 10 ? `0${currentDay}` : currentDay}/{currentmonth + 1 < 10 ? `0${currentmonth + 1}` : currentmonth + 1}/{currentyear}
                            </div>
                            <div className="day-part-nav">
                                {currentDay2}
                            </div>
                        </div>
                    </div>
                    <div className="right-part-nav">
                        <div><img className='trinagle-alert' src={tringle} /></div>
                        <div><img style={{ width: "32px", height: "32px", marginLeft: "8px", marginRight: "8px", marginTop: "8px" }} src={alert} alt="" /></div>
                        <div>
                            <i className="fa-solid fa-user fa-sm"></i>
                        </div>
                    </div>
                </nav>
            </header>

            <section className="login-section">
                <div className="left-login">
                    <img src={logo} alt="" />
                </div>
                <div className="right-login">
                    <div className="card-login">
                        <div className="card-header">
                            RMMS Platform'a Hoşgeldiniz
                        </div>
                        <div className="card-body">
                            <form onSubmit={OnFormSubmit}>
                                <h6>Giriş Yapın</h6>
                                <div className="input-group-login">

                                    <label htmlFor="email">Email</label>
                                    <input value={email} id='Email' onChange={change_email} type="text" className='login0email_input' placeholder='email' />
                                    <div className='inform_login_div'></div>
                                    <label htmlFor="password">Parolanız</label>
                                    <input value={parola} id='Password' onChange={change_pwd} type="password" className='password0login_input' placeholder='password' />
                                    <div className='inform_login_div'></div>
                                    <div className="btn_part_loginto">
                                        <div className='forget_pwd'>
                                            <p onClick={async () => {

                                                await Store.dispatch(set_temp_email(email))
                                                history.push("/forget_password")
                                            }}>Parolamı Unuttum?</p>
                                        </div>
                                        <button >Giriş <i className='fa fa-arrow-right'></i></button>
                                    </div>


                                </div>

                            </form>
                        </div>
                    </div>

                </div>

            </section>
            <div className="alert_sx-34">
                {err_code !== "" ? <div className="alert_part">{err_code}
                    <i onClick={close_the_alert} className="fa fa-times"></i></div> : <div className='alert_part_inactive'></div>}
            </div>
        </>
    )
}
const MapStateToProps = (state) => {
    return {

        auth_reducer: state.auth_reducer.user_id,
        user_email: state.auth_reducer.email

    }
}

export default connect(MapStateToProps)(Login)